import type {User} from "oidc-client-ts";

/**
 * En production, c'est KrakenD qui pose `x-auth-email` et `x-auth-userid` à partir des claims
 * `email` et `sub` du jeton (`propagate_claims`). En développement local, le front appelle les
 * API directement et court-circuite la gateway : sans ces en-têtes, elles répondent 400.
 *
 * Module isolé et sans effet de bord, pour rester testable hors navigateur.
 */

const isLocalApi = (url: string): boolean => {
  try {
    // pas de base : les URL d'API sont absolues (cf. config). Une URL relative lève, et
    // le repli à `false` est le bon défaut — dans le doute, ne rien propager.
    const {hostname} = new URL(url);
    return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "[::1]";
  } catch {
    return false;
  }
};

/**
 * La condition porte sur l'URL cible, et non sur un indicateur d'environnement : aucune URL de
 * production n'est en localhost, donc ces en-têtes ne peuvent pas fuiter hors du poste de
 * développement, même si une variable d'environnement était mal réglée.
 */
export const gatewayClaimHeaders = (url: string, user: User | null): Record<string, string> => {
  if (user === null || !isLocalApi(url)) {
    return {};
  }
  const claims: Record<string, string> = {};
  if (user.profile?.email) claims["x-auth-email"] = user.profile.email;
  if (user.profile?.sub) claims["x-auth-userid"] = user.profile.sub;
  return claims;
};
